(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nw-account"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    window.$utils.customerHandler.saveAccount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-article-details"] && !window.DesignMode) return;
  try {
    
  class ArticleCatalogue extends HTMLElement {
    // Static properties (constants for the class)
    static get HEADING_SELECTOR() {
      return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].join(',');
    }

    static get NUMBER_WORD_MAP() {
      return ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    }

    static HEADING_ID_SPECIAL_CHAR_REGEX =
      /[`~!@#$%^&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;

    static get TOC_LIST_CLASS() {
      return 'toc-list';
    }

    static get TOC_COLLAPSED_CLASS() {
      return 'toc-collapsed';
    }

    static get JUMP_LINK_CLASS() {
      return 'jump-link';
    }

    static get JUMP_TARGET_WRAPPER_CLASS() {
      return 'jump-target-wrapper';
    }

    static get JUMP_TARGET_SHOW_CLASS() {
      return 'show';
    }

    _articleDetails = null;
    _tocContainer = null;
    _tocList = null;
    _tocToggleButton = null;
    _initialized = false;

    constructor() {
      super();

      const contentSelector = this.getAttribute('data-content') || '';
      const tocSelector = this.getAttribute('data-toc') || '';

      if (contentSelector) {
        this._articleDetails = document.querySelector(contentSelector);
      }

      if (tocSelector) {
        this._tocContainer = document.querySelector(tocSelector);
      }
    }

    connectedCallback() {
      if (!this._initialized && this._articleDetails && this._tocContainer) {
        this._initialize();

        this._initialized = true;
      } else if (!this._initialized) {
        if (!this._articleDetails) {
          console.warn(
            `ArticleCatalogue: Element for data-content selector "${this.getAttribute('data-content')}" not found.`
          );
        }

        if (!this._tocContainer) {
          console.warn(`ArticleCatalogue: Element for data-toc selector "${this.getAttribute('data-toc')}" not found.`);
        }

        if (!this._articleDetails || !this._tocContainer) {
          console.warn('ArticleCatalogue: Component will not initialize due to missing essential elements.');
        }
      }
    }

    _initialize() {
      const tocTree = this._buildTocTree(this._articleDetails);
      this._createTableOfContents(tocTree);

      this._setupTocEventListeners();
      this._handleInitialHashJump();
    }

    _buildTocTree(articleWrapperNode) {
      const root = { children: [], node: null, level: 0 };
      let currentHeadingNodeInTree = root;
      const headings = Array.from(articleWrapperNode.querySelectorAll(ArticleCatalogue.HEADING_SELECTOR));

      headings.forEach((headingElement) => {
        const headingLevel = parseInt(headingElement.localName[1], 10);
        const idData = this._generateHeadingIdData(headingElement.innerText);
        headingElement.setAttribute('id', idData.underscoreText);
        headingElement.classList.add(ArticleCatalogue.JUMP_TARGET_WRAPPER_CLASS);

        const headingObj = {
          node: headingElement,
          children: [],
          parent: undefined,
          level: headingLevel,
        };

        while (currentHeadingNodeInTree !== root && currentHeadingNodeInTree.level >= headingObj.level) {
          currentHeadingNodeInTree = currentHeadingNodeInTree.parent;
        }

        headingObj.parent = currentHeadingNodeInTree;
        headingObj.parent.children.push(headingObj);
        currentHeadingNodeInTree = headingObj;
      });

      return root.children;
    }

    _generateHeadingIdData(innerText) {
      const wordArray = innerText.split(/\s+/);

      let result = '';

      for (let i = 0; i < wordArray.length; i++) {
        let lowercaseWord = wordArray[i]
          .trim()
          .toLowerCase()
          .replace(ArticleCatalogue.HEADING_ID_SPECIAL_CHAR_REGEX, '');

        lowercaseWord = lowercaseWord.replace(
          /[0-9]/g,
          (match) => ArticleCatalogue.NUMBER_WORD_MAP[parseInt(match, 10)] || match
        );

        if (lowercaseWord) {
          result += lowercaseWord + '_';
        }
      }
      const underscoreText = result.replace(/_+$/, '');
      const hyphenatedText = underscoreText.replace(/_/g, '-');
      const encodedText = encodeURIComponent(underscoreText);

      return {
        underscoreText: underscoreText,
        hyphenatedText: hyphenatedText,
        encodedText: encodedText,
      };
    }

    _createTableOfContents(tocTree) {
      this._tocContainer.innerHTML = '';
      this._tocToggleButton = this.querySelector('.article-catalogue-title-btn');
      this._tocList = document.createElement('ul');
      this._tocList.classList.add(ArticleCatalogue.TOC_LIST_CLASS);

      const createNodeRecursive = (item) => {
        const li = document.createElement('li');

        const a = document.createElement('a');
        a.classList.add(ArticleCatalogue.JUMP_LINK_CLASS);
        a.href = '#' + item.node.id;
        a.innerText = item.node.innerText;

        li.appendChild(a);

        if (item.children.length > 0) {
          const subUl = document.createElement('ul');

          item.children.forEach((child) => {
            subUl.appendChild(createNodeRecursive(child));
          });

          li.appendChild(subUl);
        }

        return li;
      };

      tocTree.forEach((node) => {
        this._tocList.appendChild(createNodeRecursive(node));
      });

      this._tocContainer.appendChild(this._tocList);
    }

    _setupTocEventListeners() {
      this._tocContainer.addEventListener('click', (event) => {
        const target = event.target;

        if (target.classList.contains(ArticleCatalogue.JUMP_LINK_CLASS) && target.tagName === 'A') {
          event.preventDefault();

          const targetId = target.getAttribute('href');

          if (targetId) {
            const elementToJump = this._articleDetails?.querySelector(targetId);

            if (elementToJump) {
              this._jumpToTargetElement(elementToJump);
            }
          }
        }
      });

      if (this._tocToggleButton) {
        this._tocToggleButton.addEventListener('click', () => this._toggleTocDisplay());
      }
    }

    _toggleTocDisplay() {
      this.classList.toggle(ArticleCatalogue.TOC_COLLAPSED_CLASS);
    }

    _jumpToTargetElement(targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      targetElement.classList.add(ArticleCatalogue.JUMP_TARGET_SHOW_CLASS);

      setTimeout(() => {
        targetElement.classList.remove(ArticleCatalogue.JUMP_TARGET_SHOW_CLASS);
      }, 1000);
    }

    _handleInitialHashJump() {
      if (window.location.hash && this._articleDetails) {
        try {
          const targetElement = this._articleDetails.querySelector(window.location.hash);

          if (targetElement) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this._jumpToTargetElement(targetElement);
              });
            });
          }
        } catch (e) {
          console.warn('ArticleCatalogue: Error trying to jump to hash target on load:', e);
        }
      }
    }
  }

  customElements.define('article-catalogue', ArticleCatalogue);

  document.addEventListener('DOMContentLoaded', function () {
    const placeholders = document.querySelectorAll('.product-card-placeholder');

    if (!placeholders.length) return;

    // Define the specific attributes you want to copy for discounts
    const discountAttributesToCopy = [
      'discount-code',
      'discount-amount',
      'discount-type',
      'discount-expiry',
      'discount-min',
    ];

    placeholders.forEach((placeholder) => {
      const productId = placeholder.getAttribute('data-product-key');

      if (!productId) return;

      const productCard = document.createElement('product-card');

      productCard.setAttribute('product-key', productId);

      // Copy only the specified discount attributes from placeholder to product card
      discountAttributesToCopy.forEach((attrName) => {
        const placeholderAttrName = `data-${attrName}`; // e.g., data-discount-code
        const value = placeholder.getAttribute(placeholderAttrName);
        if (value !== null) {
          // Check if the attribute exists and has a value
          productCard.setAttribute(attrName, value); // Set on product-card without 'data-'
        }
      });

      if (placeholder.parentNode) {
        placeholder.parentNode.replaceChild(productCard, placeholder);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-bulk-purchase"] && !window.DesignMode) return;
  try {
    
  $(function () {
    function initPageData() {
      const questionsMap = new Map();
      const answersMap = new Map();

      const questions = Array.from(document.querySelectorAll('.item-question')).map((target) => ({
        index: Number(target.getAttribute('data-index')),
        target,
        isMobile: target.parentElement.classList.contains('faq-item-wrapper'),
      }));

      const answers = Array.from(document.querySelectorAll('.item-answer')).map((target) => ({
        index: Number(target.getAttribute('data-index')),
        target,
        isMobile: target.parentElement.classList.contains('faq-item-wrapper'),
      }));

      questions.forEach(({ index, target, isMobile }) => {
        questionsMap.set(`${isMobile ? 'mobile' : 'pc'}-${index}`, target);
      });

      answers.forEach(({ index, target, isMobile }) => {
        answersMap.set(`${isMobile ? 'mobile' : 'pc'}-${index}`, target);
      });

      let activeIndex = 0;

      const handleClick = ({ index, target }) => {
        if (!target) return;

        if (index === activeIndex) return;

        toggleQuestion(activeIndex, false);
        toggleAnswer(activeIndex, false);

        requestAnimationFrame(() => {
          toggleQuestion(index, true);
          toggleAnswer(index, true);
        });

        activeIndex = index;
      };

      const toggleQuestion = (index, show = false) => {
        const pcQuestion = questionsMap.get(`pc-${index}`);
        const mobileQuestion = questionsMap.get(`mobile-${index}`);

        if (show) {
          if (pcQuestion) pcQuestion.classList.add('active');
          if (mobileQuestion) mobileQuestion.parentElement.classList.add('active');
        } else {
          if (pcQuestion) pcQuestion.classList.remove('active');
          if (mobileQuestion) mobileQuestion.parentElement.classList.remove('active');
        }
      };

      const toggleAnswer = (index, show = false) => {
        const pcAnswer = answersMap.get(`pc-${index}`);
        const mobileAnswer = answersMap.get(`mobile-${index}`);

        if (show) {
          pcAnswer.classList.add('active');
          mobileAnswer.classList.add('active');

          mobileAnswer.style.height = 'auto';
          const actualHeight = mobileAnswer.offsetHeight;
          mobileAnswer.style.height = 0;
          requestAnimationFrame(() => {
            mobileAnswer.style.height = `${actualHeight}px`;
          });
        } else {
          pcAnswer.classList.remove('active');
          mobileAnswer.classList.remove('active');

          mobileAnswer.style.height = mobileAnswer.offsetHeight + 'px';
          requestAnimationFrame(() => {
            mobileAnswer.style.height = 0;
          });
        }
      };

      questions.forEach((item) => {
        const { index, target } = item;

        toggleQuestion(index, index === activeIndex);
        toggleAnswer(index, index === activeIndex);

        target.addEventListener('click', () => handleClick(item));
      });

      window.addEventListener('beforeunload', function () {
        questions.forEach((item) => {
          const { target } = item;

          target.removeEventListener('click', () => handleClick(item));
        });
      });
    }

    window.VUtils.reloadShopifySection(initPageData);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-carousel"] && !window.DesignMode) return;
  try {
    
  $(function () {
    function initPageData() {
      const carouselDom = document.querySelector('.nw-carousel');
      if (!carouselDom) return;

      const autoplayTimeout = Number(carouselDom.getAttribute('data-duration')) * 1000;
      const autoplay = !!(autoplayTimeout !== 0);
      const slider = tns({
        container: '.nw-carousel-wrapper .nw-carousel',
        items: 1,
        prevButton: '.nw-carousel-wrapper .nw-carousel-prev',
        nextButton: '.nw-carousel-wrapper .nw-carousel-next',
        autoplayTimeout,
        autoplay,
        autoplayButtonOutput: false,
        mouseDrag: true,
        nav: true,
        navPosition: 'bottom',
        controls: false,
        responsive: {
          769: {
            nav: false,
            controls: true,
          },
        },
      });

      let isCopying = false;

      // Click on carousel items, go to url
      const items = Array.from(carouselDom.querySelectorAll('.nw-carousel-item'));

      for (const item of items) {
        const url = item.getAttribute('data-url');

        if (!url) return;

        item.addEventListener('mousedown', (e) => {
          isCopying = false;

          // console.log('mousedown', isCopying);
        });

        item.addEventListener('mousemove', (e) => {
          if (window.getSelection().toString()) {
            isCopying = true;
          }
        });

        item.addEventListener('mouseup', (e) => {
          setTimeout(() => {
            isCopying = false;

            // console.log('mouseup', isCopying);
          }, 0);
        });

        item.addEventListener('click', (e) => {
          // console.log('isCopying===', isCopying);

          if (isCopying) {
            e.preventDefault();
            e.stopPropagation();
          } else {
            window.location.href = url;
          }
        });
      }
    }
    window.VUtils.reloadShopifySection(initPageData);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-customer-reviews"] && !window.DesignMode) return;
  try {
    
  $(function () {
    function initPageData() {
      const swiper = tns({
        container: '#customer-reviews-carousel',
        items: 1,
        prevButton: '.customer-reviews-carousel-wrapper .nw-carousel-prev',
        nextButton: '.customer-reviews-carousel-wrapper .nw-carousel-next',
        autoplay: true,
        autoplayButtonOutput: false,
        nav: false,
      });
    }

    window.VUtils.reloadShopifySection(initPageData);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get DOM elements
    const header = document.getElementById('nw-header');
    const mobileMenuContainer = document.querySelector('.nw-nav-bar-wrapper');
    const body = document.body;

    // Get the dimensions of the header container
    function getHeaderContainerRect() {
      return header.querySelector('.nw-header-container').getBoundingClientRect();
    }

    // Open the mobile menu
    function openMenu() {
      const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const { top, height } = getHeaderContainerRect();
      const offsetBottom = screenHeight - top - height;
      // Set the height of the mobile menu container
      mobileMenuContainer.style.height = offsetBottom + 'px';
      // Show the header and disable scrolling
      header.classList.add('show');
      body.style.overflow = 'hidden';
    }

    // Close the mobile menu
    function closeMenu() {
      // Reset the height of the mobile menu container
      mobileMenuContainer.style.height = '';
      // Hide the header and enable scrolling
      header.classList.remove('show');
      body.style.overflow = 'auto';
    }

    // Event listeners for opening and closing the mobile menu
    document.querySelector('.mobile-open-menu-btn').addEventListener('click', openMenu);
    document.querySelector('.mobile-close-menu-btn').addEventListener('click', closeMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-login"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form#customer_login');
    const email = form.querySelector('input[name="customer[email]"]');
    const password = form.querySelector('input[name="customer[password]"]');
    const rememberMe = form.querySelector('#rememberMe');
    const submitBtn = form.querySelector('button');

    if (email && password && rememberMe && submitBtn) {
      submitBtn.addEventListener('click', function (event) {
        if (email.value === '') {
          event.preventDefault();
          email.focus();
        } else if (password.value === '') {
          event.preventDefault();
          password.focus();
        } else {
          event.preventDefault();
          window.$utils.customerHandler.set(email.value, password.value, rememberMe.checked);
          form.submit();
        }
      });

      const emailWrapper = email ? email.parentNode : null;
      const recordedEmailsText = email ? email.getAttribute('data-view-recorded-emails') : '';
      const recordList = window.$utils.customerHandler.getRecordList();
      if (emailWrapper && recordList.length) {
        let html = `<div class="view-recorded-email-wrapper"><span>${recordedEmailsText}</span><div class="recorded-email-wrapper custom-popper"><ul class="recorded-email-list">`;
        const itemsHtml = recordList.reduce((previous, current) => {
          return previous + `<li class="recorded-email-item" data-email="${current.email}">${current.email}</li>`;
        }, '');
        html += itemsHtml;
        html += '</ul><div class="popper__arrow"></div></div></div>';
        emailWrapper.insertAdjacentHTML('beforeend', html);
        emailWrapper.classList.add('has-recorded-email');

        window.$utils.nextTick(() => {
          const viewRecordedEmail = document.querySelector('.view-recorded-email-wrapper span');
          if (viewRecordedEmail) {
            viewRecordedEmail.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              this.parentNode.classList.toggle('active');
            });
          }

          const recordedEmailItems = Array.from(form.querySelectorAll('.recorded-email-item'));
          recordedEmailItems.forEach((item) => {
            item.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              const emailValue = item.getAttribute('data-email');
              const passwordValue = recordList.find((record) => record.email === emailValue).password;
              email.value = emailValue;
              password.value = window.$utils.customerHandler.getDecryptPassword(passwordValue);
              if (viewRecordedEmail) viewRecordedEmail.parentNode.classList.remove('active');
            });
          });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-our-advantages"] && !window.DesignMode) return;
  try {
    
  $(function () {
    let swiper;

    function initPageData() {
      function initSwiper() {
        if (swiper) destroySwiper();
        requestAnimationFrame(() => {
          swiper = tns({
            container: '#ourAdvantagesCarousel',
            items: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            controls: false,
            navPosition: 'bottom',
          });
          console.log('Init swiper...');
        });
      }

      function destroySwiper() {
        if (swiper) {
          swiper.destroy();
          swiper = null;
          console.log('Destroy swiper...');
        }
      }

      function onResize() {
        if (window.innerWidth < 768) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }

      window.addEventListener('resize', debounce(onResize, 300));
      onResize();
    }
    window.VUtils.reloadShopifySection(initPageData);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-product-listing"] && !window.DesignMode) return;
  try {
    
  $(function () {
    function initPageData() {
      const productCarouselClass = '#nw-product-listing .product-carousel-container';
      const productThumbnailsClass = '#nw-product-listing .product-thumbnails-container';
      const nextButtonClass = '#nw-product-listing .nw-carousel-next';
      const prevButtonClass = '#nw-product-listing .nw-carousel-prev';
      const carouselDuration = Number($(productCarouselClass).attr('data-carousel-duration') * 1000) || 0;
      const autoplayDisableOnInteraction =
        $(productCarouselClass).attr('data-autoplay-disable-on-interaction') === 'true';
      const params = {
        lazyLoading: true,
        lazyLoadingInPrevNext: true,
        roundLengths: true,
        passiveListeners: false,
        loop: false,
      };
      window.current_product_carousel = new Swiper(productCarouselClass, {
        slidesPerView: 1,
        ...params,
        nextButton: nextButtonClass,
        prevButton: prevButtonClass,
        autoplay: carouselDuration,
        autoplayDisableOnInteraction,
      });
      window.current_product_thumbnails = new Swiper(productThumbnailsClass, {
        ...params,
        width: 100,
        height: 100,
        spaceBetween: 20,
        slideToClickedSlide: true,
        lazyLoadingInPrevNextAmount: 4,
        breakpoints: {
          1100: {
            width: 100,
            height: 100,
            spaceBetween: 20,
          },
          992: {
            width: 100,
            height: 100,
            spaceBetween: 10,
          },
        },
      });
      window.current_product_carousel.params.control = window.current_product_thumbnails;
      window.current_product_thumbnails.params.control = window.current_product_carousel;
      Fancybox.bind('[data-fancybox="carousel"]', {});

      const copyBtnClass = 'copy-button-text';
      const copyBtn = document.querySelector(`#nw-product-listing .${copyBtnClass}`) || null;
      if (copyBtn) {
        const clearTooltip = (e) => {
          e.currentTarget.setAttribute('class', copyBtnClass);
          e.currentTarget.removeAttribute('aria-label');
        };

        const showTooltip = (elem, msg) => {
          elem.setAttribute('class', `${copyBtnClass} tooltipped tooltipped-s`);
          elem.setAttribute('aria-label', msg);
        };

        const fallbackMessage = (action) => {
          var actionMsg = '';
          var actionKey = action === 'cut' ? 'X' : 'C';
          if (/iPhone|iPad/i.test(navigator.userAgent)) {
            actionMsg = 'No support :(';
          } else if (/Mac/i.test(navigator.userAgent)) {
            actionMsg = 'Press ⌘-' + actionKey + ' to ' + action;
          } else {
            actionMsg = 'Press Ctrl-' + actionKey + ' to ' + action;
          }
          return actionMsg;
        };

        copyBtn.addEventListener('mouseleave', clearTooltip);
        copyBtn.addEventListener('blur', clearTooltip);
        const clipboard = new ClipboardJS(copyBtn);
        clipboard.on('success', function (e) {
          /* console.info('Action:', e.action);
          console.info('Text:', e.text);
          console.info('Trigger:', e.trigger); */
          e.clearSelection();
          showTooltip(e.trigger, 'Copied!');
        });
        clipboard.on('error', function (e) {
          /* console.error('Action:', e.action);
          console.error('Trigger:', e.trigger); */
          showTooltip(e.trigger, fallbackMessage(e.action));
        });
      }

      // In-product video setup
      const videojsList = Array.from(document.querySelectorAll('video.video-js'));
      if (videojsList && videojsList.length) {
        function formatTime(duration) {
          const minutes = Math.floor(duration / 60);
          const seconds = Math.floor(duration - minutes * 60);
          return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }

        const Component = videojs.getComponent('Component');
        class CustomTitleBar extends Component {
          constructor(player, options = {}) {
            super(player, options);
            if (options.text) {
              this.updateTextContent(options.text);
            }
          }

          createEl() {
            return videojs.dom.createEl('div', {
              className: 'vjs-custom-title-bar',
              innerHTML: `<div class="vjs-shadow-top"></div><div class="vjs-logo"><svg width="31" height="40" viewBox="0 0 31 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.50015 28.0543C4.47312 32.0814 7.72991 35.3652 11.757 35.3652H28.8112V39.8653H11.8786C5.39205 39.8653 0.0271308 34.649 0.000103488 28.1489C-0.0269238 21.6354 5.2434 16.3515 11.757 16.3515H30.2301L4.10825 4.97302V0L27.6761 10.2704C33.1626 12.6623 31.4599 20.8516 25.4733 20.8516H11.8516C7.85153 20.8516 4.54069 24.0543 4.51366 28.0408L4.50015 28.0543Z" /><path d="M28.8111 25.8516H8.48657V30.3516H28.8111V25.8516Z" /></svg></div><div class="vjs-title"></div>`,
            });
          }

          updateTextContent(text) {
            if (typeof text !== 'string') {
              text = 'Title Unknown';
            }
            this.el().querySelector('.vjs-title').textContent = text;
          }
        }

        const Button = videojs.getComponent('Button');
        class CustomBigPlayButton extends Button {
          constructor(player, options = {}) {
            super(player, options);
            if (options.duration) {
              this.updateDuration(options.duration);
            }
            this.on('click', () => {
              player.play();
            });
          }

          createEl() {
            return videojs.dom.createEl('div', {
              className: 'vjs-big-play-button',
              innerHTML: `<div class="d-flex align-items-center justify-content-center p-1 h-100 vjs-custom-big-play-button"><i class="fa fa-play" aria-hidden="true"></i><span class="vjs-video-duration"></span></div>`,
            });
          }

          updateDuration(duration) {
            if (typeof duration !== 'string') {
              duration = '00:00';
            }
            this.el().querySelector('.vjs-video-duration').textContent = duration;
          }
        }
        videojs.registerComponent('CustomBigPlayButton', CustomBigPlayButton);

        // My ES5 constructor function extending Component
        function MyComponent(arguments) {
          Component.call(this, arguments);
        }

        MyComponent.prototype = Object.create(Component.prototype);

        videojs.registerComponent('CustomTitleBar', CustomTitleBar);

        const addCustomBigPlayButton = (player, type) => {
          const duration = player.duration();
          const formattedDuration = formatTime(duration);
          player.addChild('CustomBigPlayButton', {
            duration: formattedDuration,
          });
        };

        const playerList = [];

        for (let i = 0; i < videojsList.length; i++) {
          const item = videojsList[i];
          const player = videojs(item.getAttribute('id'));

          playerList.push(player);

          player.removeChild('BigPlayButton');

          player.addChild('CustomTitleBar', {
            text: player.el().getAttribute('data-video-alt'),
          });

          player.on('loadedmetadata', () => {
            addCustomBigPlayButton(player, 'loadedmetadata');
          });

          player.on('playing', () => {
            window.current_product_carousel.stopAutoplay();
          });

          player.on('pause', () => {
            window.current_product_carousel.startAutoplay();
          });
        }

        window.current_product_carousel.on('onSlideChangeStart', function () {
          for (let i = 0; i < playerList.length; i++) {
            const player = playerList[i];
            if (!player.paused()) {
              player.pause();
            }
          }
        });
      }

      // Product pop-up video settings
      const bigPlayButtons = Array.from(document.querySelectorAll('.carousel-modal-video-big-play-button'));
      if (bigPlayButtons.length) {
        const modalWrapper = document.querySelector('.custom-product-modal-video-wrapper');
        let modalVideo = null;
        let enableScroll = null;
        function createVideo(title, width, height, poster, videoSources) {
          if (!videoSources || !videoSources.length || !modalWrapper) return;
          modalWrapper.style.setProperty('--aspect-ratio', `${height || 1} / ${width || 1}`);
          const videoElement = document.createElement('video');
          videoElement.className = 'video-js vjs-fluid';
          videoElement.setAttribute('controls', '');
          videoElement.setAttribute('preload', 'auto');
          videoElement.setAttribute('poster', poster);
          videoElement.setAttribute('aspectRatio', `${width || 1}:${height || 1}`);
          videoElement.id = 'product-modal-player';

          const videoTitle = modalWrapper.querySelector('.modal-video-title');
          if (videoTitle) videoTitle.textContent = title;

          const videoContent = modalWrapper.querySelector('.modal-video-content');
          if (videoContent) {
            videoContent.innerHTML = '';
            videoContent.appendChild(videoElement);
          }

          if (modalVideo) modalVideo.dispose();

          modalWrapper.classList.add('active');

          const afterSortSources = videoSources
            .sort((a, b) => a.height - b.height)
            .map((item) => ({
              src: item.url,
              type: item.mime_type,
              label: item.height + 'p',
            }));
          const removeMu38Sources = afterSortSources.filter((item) => item.src.indexOf('.m3u8') === -1);
          const sources = removeMu38Sources.length ? removeMu38Sources : afterSortSources;
          const reverseSources = sources.reduce((result, current) => [current, ...result], []);

          modalVideo = videojs(videoElement, {
            sources: reverseSources,
          });

          /* console.log({
            modalVideo,
            videoSources,
            afterSortSources,
            removeMu38Sources,
            sources,
            reverseSources,
            width,
            height,
            poster,
          }); */

          modalVideo.on('loadedmetadata', () => {
            modalVideo.play();
          });
        }

        for (let i = 0; i < bigPlayButtons.length; i++) {
          const bigPlayButton = bigPlayButtons[i];
          bigPlayButton.addEventListener('click', function () {
            const videoAlt = bigPlayButton.getAttribute('data-video-alt');
            const videoWidth = bigPlayButton.getAttribute('data-video-width');
            const videoHeight = bigPlayButton.getAttribute('data-video-height');
            const videoPoster = bigPlayButton.getAttribute('data-video-poster');
            const videoJsonData = JSON.parse(
              bigPlayButton.querySelector('[type="application/json"]').textContent || '{}'
            );
            createVideo(videoAlt, videoWidth, videoHeight, videoPoster, videoJsonData.sources);
            enableScroll = window.$utils.disableScroll();
            window.current_product_carousel.stopAutoplay();
          });
        }

        if (modalWrapper) {
          modalWrapper.querySelector('.modal-video-close').addEventListener('click', function () {
            modalWrapper.classList.remove('active');
            modalVideo.dispose();
            modalVideo = null;
            if (enableScroll) {
              enableScroll();
              enableScroll = null;
            }
            window.current_product_carousel.startAutoplay();
          });
        }
      }
    }
    window.VUtils.reloadShopifySection(initPageData);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-recommended-products"] && !window.DesignMode) return;
  try {
    
  const productRecommendationsContent = '.product-recommendations-wrapper';

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector(productRecommendationsContent);

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector(productRecommendationsContent);
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '50% 0px 50% 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
